function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#CCC",
  strokeWidth: 2,
  d: "M19 3c.276 0 .526.112.707.293.181.18.293.43.293.707h0v8.277l-.053-.045c-.877-.723-1.973-1.166-3.17-1.225L16.5 11l-.283.007c-1.312.067-2.503.593-3.415 1.422l-.191.182C11.616 13.606 11 14.98 11 16.5c0 .9.216 1.75.6 2.5h0H3c-.276 0-.526-.112-.707-.293C2.112 18.527 2 18.277 2 18h0V4c0-.276.112-.526.293-.707C2.473 3.112 2.723 3 3 3h0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#CCC",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13.143 3H8.857C8.386 3 8 3.3 8 3.667V9l3-1 3 1V3.667C14 3.3 13.614 3 13.143 3z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 16.5,
  r: 5.5,
  stroke: "#CCC",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M15.646 14.42c.094.093.147.22.147.353v.793h3c.552 0 1 .448 1 1s-.448 1-1 1h-3v.793c0 .276-.224.5-.5.5-.133 0-.26-.053-.354-.147l-1.793-1.793c-.195-.195-.195-.511 0-.707l1.793-1.793c.196-.195.512-.195.707 0z"
}));

function SvgReturnGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnGray);
export default __webpack_public_path__ + "static/media/return-gray.946d24b1.svg";
export { ForwardRef as ReactComponent };